import { ErrorBoundary } from 'react-error-boundary';
import { Route, Routes } from 'react-router-dom';

import RouteWithTitle from '../../../../src/routes/RouteWithTitle';
import ErrorLogger from '../../../providers/ErrorLogger';
import RouteGuard from '../../../routes/RouteGuard';
import IntegratedSearch from '../IntegratedSearch';

export const UnifiedSearchRoutes = () => {
  return (
    <Routes>
      <Route
        path="/unified-search"
        element={
          <RouteWithTitle title="">
            <RouteGuard feature="">
              <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
                <IntegratedSearch />
              </ErrorBoundary>
            </RouteGuard>
          </RouteWithTitle>
        }
      />
    </Routes>
  );
};
